const PERMISSION_KEY= "core:user_referral_plan";
const PAGE_URL = {
    USER_REFERRAL_PLAN_PAGE: "/admin/core/user-referral-plan"
}

export {PERMISSION_KEY, PAGE_URL}

